module.exports = {
	"language": "en",
	"title": "FBC Newspapers",
	"langs": {
		"pl": "Polski",
		"en": "English"
	},
	"go_top": "Go to top",
	"fonts": {
		"name": {
			"default": "default",
			"medium": "medium",
			"big": "big"
		}
	},
	"search": {
		"form": {
			"select": {
				"params": {
					"param_1": {
						"name": "Title or keywords",
						"val": "",
						"autocomplete": "suggest_main"
					},
					"param_2": {
						"name": "Title",
						"val": "title_for_search",
						"autocomplete": "suggest_newspaper_title"
					},
					"param_3": {
						"name": "Keywords",
						"val": "subject",
						"autocomplete": "suggest_subject"
					}
				}
			},
			"input": {
				"placeholder": "Enter your query"
			},
			"button": {
				"search": "Search!"
			}
		},
		"results": {
			"title": "Newspapers",
			"no_results": "No results"
		},
		"info": {
			"title": "Results",
			"count": "Number of newspapers",
			"clear": "Clear search parameters"
		},
		"main": {
			"desc": "Newspapers from collections of Polish cultural and scientific institutions"
		}
	},
	"pagination": {
		"next": "next",
		"prev": "prev",
		"next_page": "next page",
		"prev_page": "previous page",
		"from_pages": "from"
	},
	"sorting": {
		"params": {
			"relevance": {
				"name": "Sort by relevance",
				"val": ""
			},
			"title": {
				"name": "Sort by title (alphabetically)",
				"val": "newspaper_title%20asc"
			},
			"date_desc": {
				"name": "Sort by release date - from newest",
				"val": "date_start%20asc"
			},
			"date_asc": {
				"name": "Sort by release date - from oldest",
				"val": "date_end%20desc"
			}
		}
	},
	"items_per_page": {
		"label": "items per page",
		"elems": {
			"first": {
				"name": "thirty",
				"val": 30
			},
			"second": {
				"name": "sixty",
				"val": 60
			},
			"third": {
				"name": "ninty",
				"val": 90
			}
		}
	},
	"filters": {
		"title": "Filters",
		"choose": "Choose filters",
		"select_all": "Select all",
		"deselect_all": "Deselect all",
		"submit": "Apply",
		"back": "Back",
		"reset": "Reset filters",
		"add": "Add filter",
		"clean": "Clean filters",
		"close": "Close filters",
		"clear": "Clear filter",
		"clear_all": "Clear all filters",
		"search": {
			"placeholder": "Type the first letter or phrase"
		},
		"date": {
			"reset": "Reset date",
			"from": "From",
			"to": "To",
			"placeholder": "Enter the year or month or full date. You can also narrow down the dates by clicking on the chart",
			"total_number": "The total number of newspapers",
			"not_valid": "The date is not correct."
		},
		"emptylist": "No matches. Change the entered phrase."
	},
	"langCode": {
		"akk": "Akkadian",
		"gwi": "Gwich'in",
		"eka": "Ekajuk",
		"nde": "Ndebele, North; North Ndebele",
		"sve": "Serili",
		"ijo": "Ijo languages",
		"aka": "Akan",
		"yid": "Yiddish",
		"sux": "Sumerian",
		"uig": "Uighur; Uyghur",
		"ton": "Tonga (Tonga Islands)",
		"sus": "Susu",
		"mis": "Uncoded languages",
		"por": "Portuguese",
		"loz": "Lozi",
		"tog": "Tonga (Nyasa)",
		"poo": "Central Pomo",
		"sun": "Sundanese",
		"zbl": "Blissymbols; Blissymbolics; Bliss",
		"pon": "Pohnpeian",
		"min": "Minangkabau",
		"pol": "Polish",
		"suk": "Sukuma",
		"kut": "Kutenai",
		"lol": "Mongo",
		"mic": "Mi'kmaq; Micmac",
		"kur": "Kurdish",
		"iii": "Sichuan Yi; Nuosu",
		"kum": "Kumyk",
		"hol": "Holu",
		"nbl": "Ndebele, South; South Ndebele",
		"zap": "Zapotec",
		"ain": "Ainu",
		"cus": "Cushitic languages",
		"guj": "Gujarati",
		"kua": "Kuanyama; Kwanyama",
		"doi": "Dogri",
		"jbo": "Lojban",
		"zza": "Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki",
		"oto": "Otomian languages",
		"rar": "Rarotongan; Cook Islands Maori",
		"vai": "Vai",
		"rap": "Rapanui",
		"nav": "Navajo; Navaho",
		"nau": "Nauru",
		"raj": "Rajasthani",
		"nzi": "Nzima",
		"ota": "Turkish, Ottoman (1500-1928)",
		"ssw": "Swati",
		"nap": "Neapolitan",
		"jav": "Javanese",
		"uga": "Ugaritic",
		"tmh": "Tamashek",
		"nai": "North American Indian languages",
		"nah": "Nahuatl languages",
		"oss": "Ossetian; Ossetic",
		"fat": "Fanti",
		"fas": "Persian",
		"egy": "Egyptian (Ancient)",
		"fao": "Faroese",
		"zxx": "No linguistic content",
		"fan": "Fang",
		"ssa": "Nilo-Saharan languages",
		"bat": "Baltic languages",
		"mga": "Irish, Middle (900-1200)",
		"bas": "Basa",
		"nyo": "Nyoro",
		"nyn": "Nyankole",
		"gsw": "Swiss German; Alemannic; Alsatian",
		"hmo": "Hiri Motu",
		"nym": "Nyamwezi",
		"hmn": "Hmong; Mong",
		"ban": "Balinese",
		"bam": "Bambara",
		"osa": "Osage",
		"bal": "Baluchi",
		"hmj": "Gejia",
		"bak": "Bashkir",
		"bai": "Bamileke languages",
		"srr": "Serer",
		"tli": "Tlingit",
		"srp": "Serbian",
		"tlh": "Klingon; tlhIngan-Hol",
		"nya": "Chichewa; Chewa; Nyanja",
		"bad": "Banda languages",
		"srn": "Sranan Tongo",
		"pli": "Pali",
		"orm": "Oromo",
		"srd": "Sardinian",
		"kru": "Kurukh",
		"byn": "Blin; Bilin",
		"ori": "Oriya",
		"csb": "Kashubian",
		"kro": "Kru languages",
		"krl": "Karelian",
		"grt": "Garo",
		"tkl": "Tokelau",
		"afr": "Afrikaans",
		"efi": "Efik",
		"grn": "Guarani",
		"mes": "Masmaje",
		"krc": "Karachay-Balkar",
		"men": "Mende",
		"crp": "Creoles and pidgins ",
		"afh": "Afrihili",
		"sqi": "Albanian",
		"grc": "Greek, Ancient (to 1453)",
		"grb": "Grebo",
		"afa": "Afro-Asiatic languages",
		"crh": "Crimean Tatar; Crimean Turkish",
		"cre": "Cree",
		"udm": "Udmurt",
		"nwc": "Classical Newari; Old Newari; Classical Nepal Bhasa",
		"mdr": "Mandar",
		"ido": "Ido",
		"mdf": "Moksha",
		"spa": "Spanish; Castilian",
		"tiv": "Tiv",
		"ady": "Adyghe; Adygei",
		"tir": "Tigrinya",
		"zun": "Zuni",
		"zul": "Zulu",
		"wol": "Wolof",
		"sot": "Sotho, Southern",
		"kpe": "Kpelle",
		"tig": "Tigre",
		"son": "Songhai languages",
		"som": "Somali",
		"cpp": "Creoles and pidgins, Portuguese-based ",
		"rus": "Russian",
		"lit": "Lithuanian",
		"rup": "Aromanian; Arumanian; Macedo-Romanian",
		"sog": "Sogdian",
		"run": "Rundi",
		"lin": "Lingala",
		"ada": "Adangme",
		"lim": "Limburgan; Limburger; Limburgish",
		"cpf": "Creoles and pidgins, French-based ",
		"hit": "Hittite",
		"kos": "Kosraean",
		"xho": "Xhosa",
		"cpe": "Creoles and pidgins, English based",
		"kor": "Korean",
		"kon": "Kongo",
		"hin": "Hindi",
		"kom": "Komi",
		"div": "Divehi; Dhivehi; Maldivian",
		"him": "Himachali languages; Western Pahari languages",
		"got": "Gothic",
		"hil": "Hiligaynon",
		"kok": "Konkani",
		"gor": "Gorontalo",
		"gon": "Gondi",
		"din": "Dinka",
		"nub": "Nubian languages",
		"cos": "Corsican",
		"fur": "Friulian",
		"cor": "Cornish",
		"phn": "Phoenician",
		"goh": "German, Old High (ca.750-1050)",
		"cop": "Coptic",
		"snk": "Soninke",
		"ach": "Acoli",
		"yap": "Yapese",
		"tha": "Thai",
		"yao": "Yao",
		"ful": "Fulah",
		"phi": "Philippine languages",
		"ace": "Achinese",
		"ibo": "Igbo",
		"snd": "Sindhi",
		"sna": "Shona",
		"bul": "Bulgarian",
		"uzb": "Uzbek",
		"bug": "Buginese",
		"iba": "Iban",
		"tgl": "Tagalog",
		"bua": "Buriat",
		"sms": "Skolt Sami",
		"tgk": "Tajik",
		"ebg": "Ebughu",
		"mas": "Masai",
		"mar": "Marathi",
		"smo": "Samoan",
		"map": "Austronesian languages",
		"smn": "Inari Sami",
		"abk": "Abkhazian",
		"mao": "Maori",
		"man": "Mandingo",
		"mal": "Malayalam",
		"smj": "Lule Sami",
		"mak": "Makasar",
		"smi": "Sami languages",
		"mai": "Maithili",
		"mah": "Marshallese",
		"mag": "Magahi",
		"sme": "Northern Sami",
		"mad": "Madurese",
		"sma": "Southern Sami",
		"btk": "Batak languages",
		"nso": "Pedi; Sepedi; Northern Sotho",
		"myv": "Erzya",
		"wln": "Walloon",
		"slv": "Slovenian",
		"dgr": "Dogrib",
		"aar": "Afar",
		"myn": "Mayan languages",
		"aze": "Azerbaijani",
		"kmb": "Kimbundu",
		"gmh": "German, Middle High (ca.1050-1500)",
		"slk": "Slovak",
		"cmn": "Mandarin",
		"sli": "Lower Silesian",
		"mya": "Burmese",
		"sla": "Slavic languages",
		"cmc": "Chamic languages",
		"tet": "Tetum",
		"glv": "Manx",
		"ter": "Tereno",
		"aym": "Aymara",
		"fry": "Western Frisian",
		"tem": "Timne",
		"tel": "Telugu",
		"lez": "Lezghian",
		"frs": "Eastern Frisian",
		"frr": "Northern Frisian",
		"peo": "Persian, Old (ca.600-400 B.C.)",
		"fro": "French, Old (842-ca.1400)",
		"glg": "Galician",
		"let": "Lesing-Gelimi",
		"frm": "French, Middle (ca.1400-1600)",
		"gle": "Irish",
		"ski": "Sika",
		"jrb": "Judeo-Arabic",
		"gla": "Gaelic; Scottish Gaelic",
		"her": "Herero",
		"nqo": "N'Ko",
		"fra": "French",
		"deu": "German",
		"mwr": "Marwari",
		"bre": "Breton",
		"bra": "Braj",
		"mwl": "Mirandese",
		"den": "Slave (Athapascan)",
		"del": "Delaware",
		"heb": "Hebrew",
		"ewo": "Ewondo",
		"oji": "Ojibwa",
		"ewe": "Ewe",
		"jpr": "Judeo-Persian",
		"vot": "Votic",
		"sit": "Sino-Tibetan languages",
		"jpn": "Japanese",
		"sio": "Siouan languages",
		"sin": "Sinhala; Sinhalese",
		"vol": "Volapük",
		"awa": "Awadhi",
		"ron": "Romanian; Moldavian; Moldovan",
		"rom": "Romany",
		"sid": "Sidamo",
		"nor": "Norwegian",
		"kir": "Kirghiz; Kyrgyz",
		"roh": "Romansh",
		"avt": "Au",
		"non": "Norse, Old",
		"kin": "Kinyarwanda",
		"mus": "Creek",
		"kik": "Kikuyu; Gikuyu",
		"roa": "Romance languages",
		"nog": "Nogai",
		"mun": "Munda languages",
		"que": "Quechua",
		"mul": "Multiple languages",
		"gil": "Gilbertese",
		"nob": "Bokmål, Norwegian; Norwegian Bokmål",
		"ave": "Avestan",
		"shn": "Shan",
		"znd": "Zande languages",
		"ava": "Avaric",
		"fon": "Fon",
		"eus": "Basque",
		"bos": "Bosnian",
		"aus": "Australian languages",
		"nno": "Norwegian Nynorsk; Nynorsk, Norwegian",
		"xal": "Kalmyk; Oirat",
		"kho": "Khotanese; Sakan",
		"tat": "Tatar",
		"khm": "Central Khmer",
		"boh": "Boma",
		"khi": "Khoisan languages",
		"bod": "Tibetan",
		"tam": "Tamil",
		"chy": "Cheyenne",
		"pau": "Palauan",
		"chv": "Chuvash",
		"tai": "Tai languages",
		"chu": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
		"tah": "Tahitian",
		"pap": "Papiamento",
		"kha": "Khasi",
		"sgn": "Sign Languages",
		"chr": "Cherokee",
		"pan": "Panjabi; Punjabi",
		"lav": "Latvian",
		"pam": "Pampanga; Kapampangan",
		"chp": "Chipewyan; Dene Suline",
		"pal": "Pahlavi",
		"lat": "Latin",
		"cho": "Choctaw",
		"chn": "Chinook jargon",
		"chm": "Mari",
		"bnt": "Bantu (Other)",
		"tyv": "Tuvinian",
		"chk": "Chuukese",
		"pag": "Pangasinan",
		"lao": "Lao",
		"haw": "Hawaiian",
		"lam": "Lamba",
		"hau": "Hausa",
		"chg": "Chagatai",
		"hat": "Haitian; Haitian Creole",
		"sga": "Irish, Old (to 900)",
		"che": "Chechen",
		"paa": "Papuan languages",
		"lah": "Lahnda",
		"ita": "Italian",
		"day": "Land Dayak languages",
		"chb": "Chibcha",
		"cha": "Chamorro",
		"dzo": "Dzongkha",
		"lad": "Ladino",
		"lac": "Lesing-Gelimi",
		"hai": "Haida",
		"dar": "Dargwa",
		"ath": "Athapascan languages",
		"dan": "Danish",
		"dak": "Dakota",
		"isl": "Icelandic",
		"est": "Estonian",
		"msa": "Malay",
		"dyu": "Dyula",
		"ast": "Asturian; Bable; Leonese; Asturleonese",
		"urd": "Urdu",
		"hye": "Armenian",
		"asm": "Assamese",
		"wen": "Sorbian languages",
		"wel": "Welsh",
		"nld": "Dutch; Flemish",
		"ser": "Serrano",
		"sem": "Semitic languages",
		"iro": "Iroquoian languages",
		"sel": "Selkup",
		"arw": "Arawak",
		"aru": "arawá",
		"gez": "Geez",
		"art": "Artificial languages",
		"ira": "Iranian languages",
		"arp": "Arapaho",
		"twi": "Twi",
		"arn": "Mapudungun; Mapuche",
		"bla": "Siksika",
		"gem": "Germanic languages",
		"arg": "Aragonese",
		"ces": "Czech",
		"arc": "Official Aramaic (700-300 BCE); Imperial Aramaic (700-300 BCE)",
		"ypk": "Yupik languages",
		"arb": "Standard Arabic",
		"ara": "Arabic",
		"cel": "Celtic languages",
		"ceb": "Cebuano",
		"tvl": "Tuvalu",
		"yor": "Yoruba",
		"scs": "North Slavey",
		"sco": "Scots",
		"scn": "Sicilian",
		"ipk": "Inupiaq",
		"vie": "Vietnamese",
		"tut": "Altaic languages",
		"niu": "Niuean",
		"epo": "Esperanto",
		"tur": "Turkish",
		"tup": "Tupi languages",
		"oci": "Occitan (post 1500); Provençal",
		"tum": "Tumbuka",
		"tuk": "Turkmen",
		"pus": "Pushto; Pashto",
		"zho": "Chinese",
		"mos": "Mossi",
		"mon": "Mongolian",
		"lus": "Lushai",
		"fiu": "Finno-Ugrian languages",
		"nic": "Niger-Kordofanian languages",
		"nia": "Nias",
		"moh": "Mohawk",
		"luo": "Luo (Kenya and Tanzania)",
		"lun": "Lunda",
		"apa": "Apache languages",
		"zha": "Zhuang; Chuang",
		"fin": "Finnish",
		"jid": "Bu",
		"fil": "Filipino; Pilipino",
		"lui": "Luiseno",
		"fij": "Fijian",
		"bis": "Bislama",
		"lug": "Ganda",
		"hup": "Hupa",
		"hun": "Hungarian",
		"bin": "Bini; Edo",
		"lub": "Luba-Katanga",
		"szw": "Sawai",
		"lua": "Luba-Lulua",
		"bik": "Bikol",
		"und": "Undetermined",
		"was": "Washo",
		"war": "Waray",
		"bih": "Bihari languages",
		"dun": "Dusun Deyah",
		"ltz": "Luxembourgish; Letzeburgesch",
		"dum": "Dutch, Middle (ca.1050-1350)",
		"mno": "Manobo languages",
		"wal": "Walamo",
		"sat": "Santali",
		"szl": "Silesian",
		"wak": "Wakashan languages",
		"bia": "Badimaya",
		"sas": "Sasak",
		"kbd": "Kabardian",
		"mni": "Manipuri",
		"san": "Sanskrit",
		"sam": "Samaritan Aramaic",
		"dua": "Duala",
		"sal": "Salishan languages",
		"mnc": "Manchu",
		"sai": "South American Indian (Other)",
		"kaz": "Kazakh",
		"sah": "Yakut",
		"sag": "Sango",
		"kaw": "Kawi",
		"inh": "Ingush",
		"gba": "Gbaya",
		"sad": "Sandawe",
		"kau": "Kanuri",
		"kat": "Georgian",
		"ine": "Indo-European languages",
		"bho": "Bhojpuri",
		"kas": "Kashmiri",
		"ind": "Indonesian",
		"enm": "English, Middle (1100-1500)",
		"kar": "Karen languages",
		"inc": "Indic languages",
		"tso": "Tsonga",
		"tsn": "Tswana",
		"ina": "Interlingua (International Auxiliary Language Association)",
		"gay": "Gayo",
		"kan": "Kannada",
		"kam": "Kamba",
		"eng": "English",
		"anp": "Angika",
		"syr": "Syriac",
		"umb": "Umbundu",
		"kal": "Kalaallisut; Greenlandic",
		"tsi": "Tsimshian",
		"end": "Ende",
		"enc": "En",
		"ang": "English, Old (ca.450-1100)",
		"kac": "Kachin; Jingpho",
		"cau": "Caucasian languages",
		"kab": "Kabyle",
		"cat": "Catalan; Valencian",
		"kaa": "Kara-Kalpak",
		"car": "Galibi Carib",
		"syc": "Classical Syriac",
		"gaa": "Ga",
		"cai": "Central American Indian languages",
		"cad": "Caddo",
		"mlt": "Maltese",
		"zen": "Zenaga",
		"hsb": "Upper Sorbian",
		"pro": "Provençal, Old (to 1500)",
		"amh": "Amharic",
		"cym": "Welsh",
		"au": "australian",
		"ven": "Venda",
		"dsb": "Lower Sorbian",
		"mlg": "Malagasy",
		"ilo": "Iloko",
		"elx": "Elamite",
		"hrv": "Croatian",
		"ukr": "Ukrainian",
		"pra": "Prakrit languages",
		"new": "Nepal Bhasa; Newari",
		"qaa-qtz": "Reserved for local use",
		"ile": "Interlingue; Occidental",
		"ell": "Greek, Modern (1453-)",
		"alt": "Southern Altai",
		"nep": "Nepali",
		"iku": "Inuktitut",
		"alg": "Algonquian languages",
		"ale": "Aleut",
		"mkh": "Mon-Khmer languages",
		"swe": "Swedish",
		"dra": "Dravidian languages",
		"mkd": "Macedonian",
		"swa": "Swahili",
		"ber": "Berber languages",
		"nds": "Low German; Low Saxon; German, Low; Saxon, Low",
		"ben": "Bengali",
		"bem": "Bemba",
		"bel": "Belarusian",
		"ndo": "Ndonga",
		"bej": "Beja; Bedawiyet",
		"tpi": "Tok Pisin",
		"unknown": "Unknown"
	},
	"global": {
		"title": "Title",
		"subject": "Subject",
		"language": "Language",
		"place_of_publishing": "Place of publishing",
		"data_provider": "Data provider",
		"issue_period": "Issue period",
		"date_filter": "Date range",
		"count": "Number of newspapers in FBC",
		"license": "License",
		"publisher": "Publisher",
		"keywords": "Keywords",
		"show_FBC": "Show in FBC",
		"button": {
			"submit": "Submit",
			"cancel": "Cancel",
			"close": "Close",
			"totop": "To top"
		}
	},
	"header": {
		"contrast": "Change contrast",
		"font": "Change font size",
		"lang": "Change language",
		"logo": "Back to homepage"
	},
	"footer": {
		"text": {
			"first": "Service FBC newspapers is held by",
			"second": "and is a service in the",
			"PSNC": {
				"full": "Poznań Supercomputing and Networking Center",
				"short": "PSNC",
				"link": "http://www.man.poznan.pl/online/en/"
			},
			"PIONIER": {
				"full": "Polish Optical Internet PIONIER network",
				"short": "PIONIER",
				"link": "http://www.pionier.net.pl/online/en/"
			}
		},
		"menu": {
			"link_1": {
				"title": "FBC",
				"link": "https://fbc.pionier.net.pl/?lang=en"
			},
			"link_2": {
				"title": "Our partners",
				"link": "http://fbc.pionier.net.pl/pro/zrodla"
			},
			"link_3": {
				"title": "Join FBC",
				"link": "http://fbc.pionier.net.pl/pro/wspolpraca/dla-dostawcow-danych/"
			},
			"link_4": {
				"title": "FBC on Facebook",
				"link": "https://www.facebook.com/FederacjaBibliotekCyfrowych"
			},
			"link_5": {
				"title": "Contact",
				"link": "http://fbc.pionier.net.pl/pro/kontakt/"
			}
		}
	},
	"cookies": {
		"bar": {
			"text": "We use cookies to facilitate your use of our services. If you do not want the cookies to be saved on your hard disk, change the settings of your browser.",
			"link": "Check information about cookies and privacy policy."
		},
		"modal": {
			"title": "Cookies on our website",
			"text": "<p>Our website uses the cookies to facilitate your use of our services. A cookie is a small file of letters and numbers that we put on your computer if you agree. These cookies allow us to distinguish you from other users of the website which helps us to provide you with a good experience when you browse our website and allows us to improve our site. In some cases use of cookies is necessary for the proper functioning of the services provided by the website.</p><p>Most web browsers allow some control of most cookies through the browser settings. To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit <a href=\"http://allaboutcookies.org\" target=\"_blank\">allaboutcookies.org</a>.</p><p><strong>Copyright © 2017 PSNC</strong></p>"
		}
	},
	"altimg": {
		"logo": "FBC Newspapers Logo"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/locals_en.json
// module id = 209
// module chunks = 1